/* eslint-disable i18next/no-literal-string -- styles not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

const HEADER_SPACING = 6;
export const drawer = defineSlotRecipe({
  slots: ['backdrop', 'positioner', 'content', 'header', 'body', 'footer', 'title', 'description', 'closeTrigger'],
  className: 'chakra-drawer',
  base: {
    header: {
      fontWeight: 'semibold',
      fontSize: '2xl',
      paddingY: HEADER_SPACING,
      //Replacing horizontal padding with margin so the border doesn't stretch to the edge of the drawer
      paddingX: 0,
      marginX: HEADER_SPACING,
      borderBottom: '1px solid',
      borderColor: 'gray.200',
      paddingTop: 0,
    },
    body: {
      px: '6',
      py: '0',
      flex: '1',
      overflow: 'auto',
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '3',
      px: '6',
      pt: '2',
      pb: '4',
    },
    title: {
      textStyle: 'lg',
      fontWeight: 'semibold',
    },
    description: {
      color: 'fg.muted',
    },
    closeTrigger: {
      top: 5,
    },
  },

  variants: {
    size: {
      xs: {
        content: {
          maxW: 'xs',
        },
        header: {
          lineHeight: '1.75rem',
        },
      },
      sm: {
        content: {
          maxW: 'md',
        },
      },
      md: {
        content: {
          maxW: 'lg',
        },
        body: {
          fontSize: 'md',
        },
      },
      lg: {
        content: {
          maxW: '2xl',
        },
      },
      xl: {
        content: {
          maxW: '4xl',
        },
      },
      full: {
        content: {
          maxW: '100vw',
          h: '100dvh',
        },
      },
    },

    placement: {
      start: {
        positioner: {
          justifyContent: 'flex-start',
        },
        content: {
          _open: {
            animationName: {
              base: 'slide-from-left-full, fade-in',
              _rtl: 'slide-from-right-full, fade-in',
            },
          },
          _closed: {
            animationName: {
              base: 'slide-to-left-full, fade-out',
              _rtl: 'slide-to-right-full, fade-out',
            },
          },
        },
      },

      end: {
        positioner: {
          justifyContent: 'flex-end',
        },
        content: {
          _open: {
            animationName: {
              base: 'slide-from-right-full, fade-in',
              _rtl: 'slide-from-left-full, fade-in',
            },
          },
          _closed: {
            animationName: {
              base: 'slide-to-right-full, fade-out',
              _rtl: 'slide-to-right-full, fade-out',
            },
          },
        },
      },

      top: {
        positioner: {
          alignItems: 'flex-start',
        },
        content: {
          maxW: '100%',
          _open: { animationName: 'slide-from-top-full, fade-in' },
          _closed: { animationName: 'slide-to-top-full, fade-out' },
        },
      },

      bottom: {
        positioner: {
          alignItems: 'flex-end',
        },
        content: {
          maxW: '100%',
          _open: { animationName: 'slide-from-bottom-full, fade-in' },
          _closed: { animationName: 'slide-to-bottom-full, fade-out' },
        },
      },
    },

    contained: {
      true: {
        positioner: {
          padding: '4',
        },
        content: {
          borderRadius: 'l3',
        },
      },
    },
  },

  defaultVariants: {
    size: 'xs',
    placement: 'end',
  },
});
